'use client';

import { useEffect } from 'react';
import { useUserContext } from '../../context/UserContext';
import { usePagesContext } from '../../context/PagesProvider';
import { getLearnUrl } from '../../lib/frontend/learn';
import { LanguageCode } from '@elsevier-health/osmosis-shared/languages';

/**
 * Redirects the user to a different language version of the page.
 * @param {Object} props - The component props.
 * @param {ReactNode} props.children - The child components.
 */
export default function LanguageRedirect({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user } = useUserContext();
  const {
    query,
    params: { concept, lang },
    push,
  } = usePagesContext();

  useEffect(() => {
    if (!user) return;

    const urlLanguage = lang || LanguageCode.EN;
    const userLanguage = user?.language || LanguageCode.EN;

    if (urlLanguage === userLanguage) return;

    push(
      getLearnUrl({
        concept,
        language: userLanguage,
        query: query as Record<string, string>,
      }),
    );
  }, [lang, user?.language]);

  return children;
}
